import { Routes } from '@angular/router';
import { activityViewGuard } from '../core/guards/auth.guard';
import { ActivityListComponent } from './pages/activity-list/activity-list.component';

export default [
	{
		path: '',
		loadComponent: () => ActivityListComponent,
		canActivate: [activityViewGuard],
		data: {
			comeback: 'panel',
		},
	},
] as Routes;
